/**
 * The sub-competition (division / pool) the select should hold.
 *
 * `values.scheduleId` is seeded from the game's own `schedule.id`, which is the
 * competition the game is filed under -- and that is NOT always a division. A
 * game filed directly on the season carries the SEASON's id, while the select
 * only offers the competition's deepest level (its divisions). The two never
 * match in that case, and antd's `Select` renders an unmatched value as raw
 * text, so the field displayed a bare id like `MNjHLMDkGjm0RhsD`.
 *
 * Resolution order:
 *   1. the seeded value, when it is genuinely one of the options;
 *   2. otherwise the first option, so a competition with divisions lands on a
 *      real one rather than showing an id or an empty required field;
 *   3. `null` when there is nothing to pick.
 *
 * Returning the first option is a real choice made on the admin's behalf, so
 * the caller must WRITE it into form state rather than only display it -- a
 * value shown but not stored would submit the season id the field appears to
 * have replaced. `useGameForm` commits it.
 *
 * Call this ONLY once the option list has actually answered. An empty list is
 * not evidence of a mismatch while the query is still idle or in flight, and
 * resolving in that window discards a legitimate seeded division -- which then
 * falls to the first option and silently moves the game.
 */
export const pickSubCompetitionValue = (
  scheduleId: string | null,
  options: Array<{ value: string }>
): string | null => {
  if (scheduleId && options.some((option) => option.value === scheduleId)) {
    return scheduleId
  }

  return options[0]?.value ?? null
}
